"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _SortUp = _interopRequireDefault(require("@rsuite/icon-font/lib/direction/SortUp"));

// Generated by script, don't edit it please.
var SortUp = (0, _createSvgIcon["default"])({
  as: _SortUp["default"],
  ariaLabel: 'sort up',
  category: 'direction',
  displayName: 'SortUp'
});
var _default = SortUp;
exports["default"] = _default;
module.exports = exports.default;